module.exports = __webpack_public_path__ + "static/assets/23d0b6d2437ce7e2b879572552bba35b.svg";